type TupleEntry<T extends readonly unknown[], I extends unknown[] = [], R = never> = T extends readonly [infer Head, ...infer Tail]
  ? TupleEntry<Tail, [...I, unknown], R | [`${I['length']}`, Head]>
  : R;

type ObjectEntry<T extends object> = T extends object
  ? { [K in keyof T]: [K, Required<T>[K]] }[keyof T] extends infer E
    ? E extends [infer K, infer V]
      ? K extends string | number
        ? [`${K}`, V]
        : never
      : never
    : never
  : never;

export type Entry<T extends object> = T extends readonly [unknown, ...unknown[]]
  ? TupleEntry<T>
  : T extends ReadonlyArray<infer U>
    ? [`${number}`, U]
    : ObjectEntry<T>;

export function typedEntries<T extends object>(object: T): ReadonlyArray<Entry<T>> {
  // eslint-disable-next-line no-restricted-syntax -- Object.entries erases the key-to-value pairing down to [string, T[keyof T]]; Entry<T> reconstructs it, and no assignability relation survives the widening.
  return Object.entries(object) as unknown as ReadonlyArray<Entry<T>>;
}
